// removed by extract-text-webpack-plugin
module.exports = {"vpCodecSupportWarning":"vpCodecSupportWarning___2ew5i","vpCodecSupportWarningDismissButton":"vpCodecSupportWarningDismissButton___3lClt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CodecWarning.module.less
// module id = 2574
// module chunks = 29